var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        label: "Update",
        submitLoading: _vm.submitLoading,
        disabled: _vm.isDisabledSubmit
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onSubmit
      }
    },
    [
      _c(
        "div",
        { style: { width: "45rem", maxHeight: "calc(100vh - 16rem)" } },
        [
          _c("BlTextTitle4", {
            staticClass: "px-8 pt-10 mb-8",
            attrs: { text: "Edit task" }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex flex-col gap-4 px-8 pb-4 overflow-y-auto",
              staticStyle: { "max-height": "calc(100vh - 23rem)" }
            },
            [
              _vm._l(_vm.defaultTasks, function(item) {
                return _c("div", { key: item.id }, [
                  _c("div", { staticClass: "flex items-center gap-2 " }, [
                    _c(
                      "div",
                      { staticClass: "w-full pb-3 border-b" },
                      [
                        _c("BlTextBody2", {
                          staticClass: "text-slate-1000",
                          attrs: { text: item.code + " - " + item.title }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "flex-shrink-0 w-5 pb-3",
                        on: {
                          click: function($event) {
                            !item.is_used && _vm.deleteTask(item)
                          }
                        }
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "w-5 h-5",
                          class: !item.is_used
                            ? "cursor-pointer"
                            : "cursor-not-allowed",
                          attrs: {
                            icon: !item.is_used ? "delete" : "delete",
                            color: !item.is_used ? "error" : "grey",
                            tooltip: item.is_used
                              ? "This task has recorded data and cannot be deleted"
                              : "",
                            "tooltip-position": "bottom-left"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.newTasks, function(newTask) {
                return _c("div", { key: newTask.key }, [
                  _c(
                    "div",
                    { staticClass: "flex flex-col gap-2 pb-3 border-b" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center w-full gap-4" },
                        [
                          _c("BlSelectBox", {
                            key:
                              "select-" +
                              newTask.key +
                              "-" +
                              (_vm.selectBoxKeys[newTask.key] || 0),
                            staticClass: "flex-shrink-0 w-32",
                            attrs: {
                              options: _vm.getFilteredCodeOptions(newTask.key),
                              placeholder: "Code",
                              position: "bottom"
                            },
                            on: {
                              change: function(value) {
                                return _vm.onChangeCode(value, newTask.key)
                              }
                            },
                            model: {
                              value: _vm.taskCodeSelections[newTask.key],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.taskCodeSelections,
                                  newTask.key,
                                  $$v
                                )
                              },
                              expression: "taskCodeSelections[newTask.key]"
                            }
                          }),
                          _vm._v(" "),
                          _c("BlInputText", {
                            staticClass: "w-full",
                            attrs: {
                              input: _vm.getTaskInput(newTask.key).titleInput
                            },
                            on: {
                              changed: function(payload) {
                                return _vm.inputHandler(
                                  payload,
                                  newTask.key,
                                  "title"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "relative flex items-center justify-between flex-shrink-0 w-16 px-4 border rounded cursor-pointer bg-pure-white border-grey-200 h-11"
                            },
                            [
                              _c("div", {
                                staticClass: "w-20 h-1",
                                style: {
                                  backgroundColor: newTask.color || "#2AB1A8"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex-shrink-0 w-5" })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex items-start gap-2" },
                        [
                          _c("BlInputText", {
                            attrs: {
                              input: _vm.getTaskInput(newTask.key)
                                .descriptionInput
                            },
                            on: {
                              changed: function(payload) {
                                return _vm.inputHandler(
                                  payload,
                                  newTask.key,
                                  "description"
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.deleteNewTask(newTask.key)
                                }
                              }
                            },
                            [
                              _c("BlIcon", {
                                staticClass: "w-5 h-5 cursor-pointer",
                                attrs: { icon: "delete", color: "error" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              }),
              _vm._v(" "),
              !_vm.allTasksUsed
                ? _c("BlInputButton", {
                    staticClass: "self-start px-0",
                    attrs: { label: "Add task", icon: "plus", type: "plain" },
                    on: { clicked: _vm.onAddTasks }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.allTasksUsed
                ? _c(
                    "BlTooltip",
                    {
                      staticStyle: { width: "fit-content" },
                      attrs: {
                        drop: "top",
                        tooltip:
                          "You've reached the limit for tasks and can't create a new one."
                      }
                    },
                    [
                      _c("BlInputButton", {
                        staticClass: "self-start px-2 cursor-not-allowed",
                        attrs: {
                          label: "Add task",
                          icon: "plus",
                          type: "plain",
                          disabled: ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a3bc12b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3bc12b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/modal/EditTargetTaskDetailsModal.vue
// module id = null
// module chunks = 